module.exports = __webpack_public_path__ + "img/LATIN10_33.4614e8dd.jpg";